import store from 'src/store/store'
import { logout } from 'src/api-services/account.js';
import router from "src/router";

class AuthService {
  async logOut() {
      logout(store.getters.refreshToken).then(() =>{
        this.clearStore()
        router.push("/login").catch(() => {});
      }).catch((err) => {
        if (err.response.data.errors[0].title === 'RefreshTokenNotFound') {
          logout(store.getters.refreshToken).then(() =>{
            this.clearStore()
            router.push("/login").catch(() => {});
          })
        }
      })
  }

  clearStore() {
    store.commit("SET_USER_STEP", null)
    store.commit("SET_ACCESS_TOKEN", null)
    store.commit("SET_REFRESH_TOKEN", null)
    store.commit("SET_USER_ID", null)
    store.commit("SET_USER_INFO", null)
    store.commit("SET_ACCOUNT_INFO", null)
    localStorage.setItem("hasLoginedYet", false)
  }

  isAuthenticated() {
    // const auth = localStorage.getItem('authToken')
    const auth = store.getters.authToken
    return (
      // new Date(Date.now()) < new Date(localStorage.getItem('expiresIn')) &&
      (auth ? true : false)
    );
  }
}

export default new AuthService();
